import React, { useCallback, useMemo, useState } from "react";

import RemoteGame, { OnlineSession } from "../play/game/RemoteGame";
import styles from "./modes.module.scss";

// The Play Now game itself: finds the fullest room with a seat (the server's
// matchmaker), drops in, and plays until you leave. Used by its own page and by
// the pages that let you play while you wait (the Royale's sign-up, a ranked
// search), which pass their banner as children.
//
// `matchId`: a concrete room to rejoin (a reload: "?m=12" -> "public:playnow#12").
export default function PlayNowGame({ matchId, onLeave, onRoomInstance, localPlayers, children }: {
  matchId?: string | null;
  onLeave: () => void;
  onRoomInstance?: (instance: string) => void;
  // Several people on this keyboard (the Play Now page's "Who's playing?").
  // Left out, it is one player: playing while you wait for a Royale or a ranked game.
  localPlayers?: Array<{ name: string; colorId: string; left: string | null; right: string | null; flag?: string; victoryAnim?: string | null; headStyle?: string | null }>;
  children?: React.ReactNode;
}) {
  // Bumped to join afresh through the matchmaker (the room handed us on).
  const [joinKey, setJoinKey] = useState(0);
  const roomId = useMemo(
    () => (joinKey === 0 && matchId ? "public:playnow#" + matchId : "public:playnow"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [joinKey]
  );
  const [session, setSession] = useState<OnlineSession | null>(null);
  const rejoin = useCallback(() => { setSession(null); setJoinKey((k) => k + 1); }, []);
  const finding = !session || session.phase === "connecting" || session.phase === "waiting";

  return (
    <>
      <div className={`${styles.game} page-main page-main-game`}>
        <RemoteGame key={joinKey} roomId={roomId} onSession={setSession} onRoomInstance={onRoomInstance} onLeave={onLeave} onPlayAgain={rejoin} localPlayers={localPlayers} />
      </div>
      {finding && (
        <div className={styles.cover}>
          <div className={styles.findCard}>
            <div className={styles.radar}><i /><i /><i /></div>
            <h3>Finding a game</h3>
            <button className={styles.ghost} onClick={onLeave}>Cancel</button>
          </div>
        </div>
      )}
      {!finding && children}
    </>
  );
}
